<template>
  <div class="tab-container" style="display: flex; flex-direction: column">
    <div style="display: flex; flex-direction: row; background-color: white; align-items: center">
      <div class="topNav" id="topNav">
        <ul id="topNavUl">
          <li v-for="(i, index) in title" :key="index" :ref="'card-' + index" @click="goCenter(i.id, index, $event, i)">
            <div style="display: flex; flex-direction: column; align-items: center">
              <div :class="selectindex === index ? 'imagback' : 'unimagback'"><img class="img" :src="i.icon" /></div>
              <span :class="selectindex === index ? 'title-sty' : 'untitle-sty'">{{ i.name }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div @click="showAll" class="show-all-btn">
        <span>全</span>
        <span>部</span>
        <van-icon size="0.75rem" name="wap-nav" />
      </div>
    </div>
    <div v-if="show" class="pop">
      <div style="max-height: 19rem; overflow-y: scroll">
        <van-grid :border="false" :column-num="5">
          <van-grid-item v-for="(i, index) in title" :key="index">
            <div style="display: flex; flex-direction: column; align-items: center" @click="clickCard(index, true)">
              <div class="wbimagback"><img class="img" :src="i.icon" /></div>
              <span :class="selectindex === index ? 'title-sty' : 'noctitle-sty'">{{ i.name }}</span>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
      <div @click="clossPop" class="close-pop-btn">
        <span>收起</span>
        <van-icon size="0.85rem" name="arrow-up" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    title: {
      type: Array
    },
    index: {
      type: Number,
      default: -1
    },
    type: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      selectindex: this.index,
      currentTopNav: '',
      show: false,
      getDate: true
    }
  },
  created() { },
  components: {},
  methods: {
    clossPop() {
      this.show = false
    },
    showAll() {
      this.show = true
      this.$emit('clossSecondPop')
    },
    clickCard(index, getDate) {
      this.getDate = getDate
      setTimeout(() => {
        if (index >= 0) {
          this.$refs[('card-' + index)][0].click();
        } else {
          this.selectindex = index
        }
      }, 200);
    },
    indexTo(index, getDate) {
      this.getDate = getDate
      this.$refs[('card-' + index)][0].click();
    },
    goCenter(id, index, e, record) {
      if (this.show) {
        this.show = false
      }
      this.selectindex = index
      let destination = index - 2;
      destination = destination < 0 ? 1 : destination;
      this.currentTopNav = id;
      if (this.navScroll) {
        this.navScroll.scrollToElement(
          document.querySelector('#topNav li:nth-child(' + destination + ')')
        );
      }
      this.getdata(index);
      // 横向滑动居中
      let ul = document.querySelector('#topNavUl');
      let nav = document.getElementById("topNav");
      let window_offsetWidth = window.innerWidth; //屏幕宽度;
      let dom = e.target;
      if (dom && ul) {
        let domoffsetWidth = dom.offsetLeft,
          //中间值 =( 屏幕宽度 - li宽度 ) / 2;
          diffWidth = (window_offsetWidth - dom.offsetWidth) / 2,
          //目标值 = offset - 中间值
          targetOffset = -(domoffsetWidth - diffWidth);
        let ul_width = ul.getBoundingClientRect().width;//开始

        // 未超出中间值
        if (-targetOffset < 0) {
          nav.scrollLeft = 0;
          return;
        }
        //末尾
        if (targetOffset < window_offsetWidth - ul_width) {
          nav.scrollLeft = -(window_offsetWidth - ul_width);
          return;
        }
        //正常
        nav.scrollLeft = -targetOffset
      }
    },
    getdata(index) {
      if (this.getDate) {
        this.$emit('scrollToAll', index)
      } else
        this.getDate = true
    }

  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.tab-container {
  position: relative;
  width: 100%;
}

.topNav {
  background: #fff;
  display: flex;
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  ul {
    display: inline-flex;
    align-items: flex-end;
    white-space: nowrap;
    padding: 0.4rem 0;

    li {
      display: inline-block;
      padding: 0 0.35rem;
    }
  }
}

/* 图标样式 - 参考设计更大更清晰 */
.img {
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 0.6rem;
  object-fit: cover;
}

/* 选中状态 - 红色边框 */
.imagback {
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #e74c3c;
  background: #fff;
  border-radius: 0.7rem;
  padding: 0.1rem;
}

/* 弹出层图标容器样式 */
::v-deep .van-grid-item__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  padding: 0.4rem 0;
  background-color: #fafafa;
}

/* 未选中状态 */
.unimagback {
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid transparent;
  border-radius: 0.7rem;
  padding: 0.1rem;
}

/* 弹出层内的图标背景 */
.wbimagback {
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

/* 全部按钮 - 竖排单字 */
.show-all-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: white;
  font-size: 0.68rem;
  color: #333;
  line-height: 1.1;
  width: 2rem; /* 固定宽度 */
  min-width: 2rem;
  border-left: 1px solid #f0f0f0;
}

/* 收起按钮 - 简洁风格 */
.close-pop-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.5rem 0;
  font-size: 0.75rem;
  color: #888;
  border-top: 1px solid #eee;
  margin-top: 0.3rem;
}

/* 选中文字样式 */
.title-sty {
  color: #e74c3c;
  font-size: 0.72rem;
  margin-top: 0.2rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 5rem; /* 增加宽度，支持5-6个汉字 */
  text-align: center;
}

/* 未选中文字样式 */
.untitle-sty {
  color: #333;
  font-size: 0.72rem;
  margin-top: 0.2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 5rem; /* 增加宽度，支持5-6个汉字 */
  text-align: center;
}

/* 弹出层内未选中文字 */
.noctitle-sty {
  color: #333;
  font-size: 0.72rem;
  margin-top: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 5rem; /* 增加宽度 */
  text-align: center;
}

/* 弹出层容器 - 完全覆盖原有分类栏 + 动画 */
.pop {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 9999;
  background-color: #fff;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  /* 动画效果 */
  animation: slideDown 0.25s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
